import React from 'react';
import { checkoutUrl } from '../services/access';
import './Paywall.css';

/**
 * Shown when someone tries to ask a second question without having unlocked.
 * The pending question is held and sent automatically once they return from
 * checkout, so paying does not cost them what they had already typed.
 */
function Paywall({ pendingQuestion, onClose, onSignIn }) {
  return (
    <div
      className="paywall-overlay"
      role="dialog"
      aria-modal="true"
      aria-labelledby="paywall-title"
    >
      <div className="paywall-backdrop" onClick={onClose} />
      <div className="paywall-panel">
        <button
          type="button"
          className="paywall-close"
          onClick={onClose}
          aria-label="Close"
        >
          ×
        </button>

        <span className="paywall-glyph" aria-hidden="true">✦</span>
        <h3 id="paywall-title">Continue your reading</h3>
        <p className="paywall-sub">
          Your first question is on us. Unlock full access to keep asking about
          your chart — career, timing, relationships, and everything else it holds.
        </p>

        {pendingQuestion && (
          <div className="paywall-pending">
            <span className="paywall-pending-label">Your question</span>
            <p>{pendingQuestion}</p>
          </div>
        )}

        <a className="paywall-cta" href={checkoutUrl()}>
          Unlock full access
        </a>

        <p className="paywall-note">
          You will be taken to our payment provider and returned here
          afterwards. Your question is saved.
        </p>

        {/* Someone who already pays should never be asked to pay twice just
            because this is a different phone or browser. */}
        <div className="paywall-divider"><span>already subscribed?</span></div>

        <button type="button" className="paywall-signin" onClick={onSignIn}>
          Sign in to restore access
        </button>
      </div>
    </div>
  );
}

export default Paywall;
